import { render, staticRenderFns } from "./DirectivesPage.vue?vue&type=template&id=f700f30c&scoped=true&"
import script from "./DirectivesPage.vue?vue&type=script&lang=js&"
export * from "./DirectivesPage.vue?vue&type=script&lang=js&"
import style0 from "./DirectivesPage.vue?vue&type=style&index=0&id=f700f30c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f700f30c",
  null
  
)

export default component.exports